module.exports = __webpack_public_path__ + "media/step4_Kernaufgaben_animation.fb2a5630.webm";